export const organizationRequiredMessage = (fieldName: string) =>
  `Please enter the organization ${fieldName}.`;
